import * as type from "../../types/API/showHideColumnsType";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getColumnsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_COLUMNS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_COLUMNS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData.data,
      };
    case type.GET_COLUMNS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addColumnReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_COLUMNS:
      return {
        ...state,
        loading: true,
      };
    case type.ADD_COLUMNS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData.message,
      };
    case type.ADD_COLUMNS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editColumnReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_COLUMNS:
      return {
        ...state,
        loading: true,
      };
    case type.EDIT_COLUMNS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData.message,
      };
    case type.EDIT_COLUMNS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteColumnReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_COLUMNS:
      return {
        ...state,
        loading: true,
      };
    case type.DELETE_COLUMNS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData.message,
      };
    case type.DELETE_COLUMNS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};